import React, { useEffect, useState } from 'react';
import { ActionButton, List, ListItem } from '@icarros/ids-react';
import { ButtonModifier, ListItemModifier } from './style';
import { scrollWindowTo } from '../../../../utils/scroll';
import { AdInterface } from '../../../../store/contexts/types/ad';

type SelectedBoxes = {
  security: number[] | undefined;
  comfort: number[] | undefined;
  sound: number[] | undefined;
  seatsAndWindows: number[] | undefined;
  other: number[] | undefined;
};

interface OptionalsListProps {
  label: string;
  selectedType: number[] | undefined;
  optionalsList: AdInterface['veiculo']['opcionais'];
  selectedBoxesOption: 'security' | 'comfort' | 'sound' | 'seatsAndWindows' | 'other';
  setSelectedBoxes: React.Dispatch<React.SetStateAction<SelectedBoxes>>;
  searchQuerySize: number;
  shouldStartOpen: boolean;
}

export function OptionalsList({
  label,
  selectedType,
  optionalsList,
  setSelectedBoxes,
  selectedBoxesOption,
  searchQuerySize,
  shouldStartOpen
}: OptionalsListProps): JSX.Element {
  const [hideContent, setHideContent] = useState(true);
  const [currentPosition, setCurrentPosition] = useState(0);
  const optionalsWithSelection = optionalsList.map(optional => ({
    ...optional,
    isSelected: selectedType?.includes(optional.id)
  }));
  const selectedOptionalsLength = optionalsWithSelection.filter(
    optional => optional.isSelected
  ).length;
  const isEveryOptionSelected = optionalsWithSelection.every(option => option.isSelected);
  const textNormalScenario = `${selectedOptionalsLength} de ${optionalsList.length}`;
  const customQuerySizeLength = 2;

  const selectedItensOnTop = optionalsWithSelection.sort((a, b) =>
    a.isSelected && !b.isSelected ? -1 : 1
  );

  useEffect(() => {
    if (searchQuerySize > customQuerySizeLength) {
      return setHideContent(false);
    }

    return setHideContent(true);
  }, [searchQuerySize]);

  if (optionalsList.length <= 0 || !selectedType) {
    return <></>;
  }

  function handleCurrentPosition() {
    if (hideContent) {
      const position = window.scrollY;
      setCurrentPosition(position);
    }
    if (!hideContent) {
      scrollWindowTo(currentPosition);
    }
  }

  return (
    <>
      <List>
        <ListItemModifier isFirst>
          <ListItem label={label} variant="simple" descript={textNormalScenario} />
        </ListItemModifier>
        <>
          {selectedItensOnTop.map(({ id, isSelected, nome }) => {
            const shouldShowSelection = !(hideContent && !isSelected) || shouldStartOpen;
            return (
              <React.Fragment key={id}>
                {shouldShowSelection && (
                  <ListItemModifier>
                    <ListItem
                      initialValue={isSelected}
                      label={nome}
                      variant="selector"
                      selectorVariant="checkbox"
                      selectorName={nome}
                      selectorOnChange={() =>
                        setSelectedBoxes(prevState => {
                          const currentOptionalsList = selectedType ? selectedType : [];
                          const shouldAdd = isSelected
                            ? currentOptionalsList.filter(filterOptional => filterOptional !== id)
                            : [...currentOptionalsList, id];
                          return {
                            ...prevState,
                            [selectedBoxesOption]: shouldAdd
                          };
                        })
                      }
                    />
                  </ListItemModifier>
                )}
              </React.Fragment>
            );
          })}
        </>
      </List>
      {searchQuerySize > customQuerySizeLength || isEveryOptionSelected || (
        <ButtonModifier>
          <ActionButton
            onClick={() => {
              handleCurrentPosition();
              setHideContent(prevState => !prevState);
            }}
            text={hideContent ? 'mostrar mais' : 'mostrar menos'}
            iconName={hideContent ? 'itaufonts_mais' : 'itaufonts_minimizar'}
            variant="secondary"
            weight="medium"
          />
        </ButtonModifier>
      )}
    </>
  );
}
